import { render, staticRenderFns } from "./employeeBasicDetails.vue?vue&type=template&id=43c33f4e&scoped=true"
import script from "./employeeBasicDetails.vue?vue&type=script&lang=js"
export * from "./employeeBasicDetails.vue?vue&type=script&lang=js"
import style0 from "./employeeBasicDetails.vue?vue&type=style&index=0&id=43c33f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c33f4e",
  null
  
)

export default component.exports